// Shared button class constants — use these across all feature pages for consistency.
import { type } from "./typography";

const base = `inline-flex items-center justify-center px-4 py-2 rounded-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${type.button}`;
const small = `inline-flex items-center justify-center px-3.5 py-2 rounded-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-xs font-medium`;

export const btn = {
  // Primary — main action (Save, Submit)
  primary: `${base} bg-gray-900 text-white hover:bg-gray-700`,

  // Apply — apply/update action, matches MUI Slider blue
  apply: `${base} bg-[#1976d2] text-white hover:bg-[#1565c0]`,
  applySmall: `${small} bg-[#1976d2] text-white hover:bg-[#1565c0]`,

  // Destructive — dangerous action (Turn Off, Delete, Run Cleanup)
  destructive: `${base} bg-red-600 text-white hover:bg-red-700`,
  destructiveSmall: `${small} bg-red-600 text-white hover:bg-red-700`,

  // Positive — turn on, activate, confirm
  positive: `${base} bg-green-600 text-white hover:bg-green-700`,
  positiveSmall: `${small} bg-green-600 text-white hover:bg-green-700`,

  // Secondary — low-priority action (Refresh, Cancel)
  secondary: `${base} bg-white border border-gray-300 text-gray-700 hover:bg-gray-50`,
  secondarySmall: `${small} bg-white border border-gray-300 text-gray-700 hover:bg-gray-50`,
};
